import {AndCondition, OrCondition, NotCondition} from "../conditions/Operators";
import {NthPageVisitCondition} from "../conditions/NthPageVisitCondition";
import {InactiveCondition} from "../conditions/InactiveCondition";
import {AdBlockEnabledCondition} from "../conditions/AdBlockEnabledCondition";
import {StayOnPageCondition} from "../conditions/StayOnPageCondition";
import {UserAgentCondition} from "../conditions/UserAgentCondition";
import {USER_DATA_CONDITIONS, UserDataCondition} from "../conditions/UserDataCondition";
import {PageScrollCondition} from "../conditions/PageScrollCondition";
import {FunctionCondition} from "../conditions/FunctionCondition";
import {VariableCondition} from "../conditions/VariableCondition";
import {UTMCondition} from "../conditions/UTMCondition";
import {PathCondition, ReferrerCondition} from "../conditions/PathCondition";
import {CookieCondition} from "../conditions/CookieCondition";
import {ExprCondition} from "../conditions/ExprCondition.js";

export const OperatorType = {
    AND: "and",
    OR: "or",
    NOT: "not",
};

/** @type {Object<string, typeof Condition>} */
export const ConditionClassMap = {
    [OperatorType.AND]: AndCondition,
    [OperatorType.OR]: OrCondition,
    [OperatorType.NOT]: NotCondition,
    "expr": ExprCondition,    
    "function": FunctionCondition,
    "variable": VariableCondition,
    "inactive": InactiveCondition,
    "stayOnPage": StayOnPageCondition,
    "pageScroll": PageScrollCondition,
    "nthPage": NthPageVisitCondition,
    "adBlockEnabled": AdBlockEnabledCondition,
    "userAgent": UserAgentCondition,
    "utm": UTMCondition,
    "path": PathCondition,
    "referrer": ReferrerCondition,
    "cookie": CookieCondition,
    [USER_DATA_CONDITIONS.isAuthenticated]: UserDataCondition,
    [USER_DATA_CONDITIONS.isSubscriber]: UserDataCondition,
    [USER_DATA_CONDITIONS.isDonor]: UserDataCondition,
};
